import React from 'react';

import {
  UserStatus,
  useGetDashboardVerifiersCountGroupedByCredentialStatusQuery,
  VerifierCredentialStatus,
} from 'src/api';
import { BusinessRole } from 'src/constants/user';
import { OverviewCredentialedVerifiers } from 'src/types/dashboard';
import { buildCreatedAtBeforeDateFilter } from 'src/utils/dashboard';

import { useDashboardCVAdminData } from './useDashboardCVAdminData';

export const useOverviewCredentialedVerifiers = () => {
  const { date } = useDashboardCVAdminData();

  const { data, loading } = useGetDashboardVerifiersCountGroupedByCredentialStatusQuery({
    variables: {
      where: {
        ...buildCreatedAtBeforeDateFilter(date.toISO()),
        verifierStaffs: {
          some: {
            user: {
              status: { equals: UserStatus.Active },
            },
            role: { equals: BusinessRole.VerifierAdmin },
          },
        },
      },
    },
  });

  const verifiers = React.useMemo(() => {
    const result: OverviewCredentialedVerifiers = {
      [VerifierCredentialStatus.Credentialed]: 0,
      [VerifierCredentialStatus.NotCredentialed]: 0,
    };

    for (const group of data?.getDashboardVerifiersCountGroupedByCredentialStatus ?? []) {
      if (group.status === VerifierCredentialStatus.Credentialed) {
        result[VerifierCredentialStatus.Credentialed] += group.count;
      } else {
        // kinda lame naming, since we put all other statuses here too, but have no better idea
        result[VerifierCredentialStatus.NotCredentialed] += group.count;
      }
    }
    return result;
  }, [data]);

  return { verifiers, verifiersLoading: loading };
};
